import {
  Component, EventEmitter, HostListener, Input, OnInit,/*  */
  Output
} from "@angular/core";
import { Router } from "@angular/router";
import { Campaign3TestService } from "../services/campaign3testservice";
import { Campaign3Campaign } from "../models/campaign-3.model";
import { CalendarTranslateService } from "app/modules/UIKit/services/calendarTranslate.service";
import { ActionStateService } from "../services/actionstate.service";
import { AuthService } from "app/services/user/auth.service";
import { LoyaltyAcmService } from "app/services/loyalty/loyalty-acm.service";
import { zip } from "rxjs/operators";
import { Observable } from "rxjs";
import { Campaign3Service } from "../services/campaign3.service";


@Component({
  selector: 'app-action-table3',
  templateUrl: './action-table3.component.html',
  styleUrls: ['./action-table3.component.css']
})
export class ActionTable3Component implements OnInit {

  @Input() actionData;
  @Input() campaign;
  @Output() refreshCampaignActions = new EventEmitter();


  menuCreationActive = false;
  showMenu = false;
  currentOpenedRow;
  showPopupInfoInsideTable = false;
  actionTypes: Array<{ label: string, value: number, code: string }>;
  campaignList: Array<Campaign3Campaign> = [];
  singleAction: any;
  language: string = "it";
  acmNoBurned :Array<any>

  constructor(public router: Router,
              public testService: Campaign3TestService,
              public srvCalendar: CalendarTranslateService,
              public actionStateService: ActionStateService,
              private authService: AuthService,
                private srvLoyaltyAcm: LoyaltyAcmService,
                private campaignService : Campaign3Service
            ) {
  }

  showTable=false;

ngOnInit() {
  if (this.actionData) {
    this.initMenuActivated();
  }

  this.language = this.authService.sessionHelper.selectedLanguage;

  const ACTION_TYPES = this.testService.getActionTypes();
  const LISTA_ACCUMULATORI = this.srvLoyaltyAcm.getAllAcmNoBurned();
  const LISTA_CAMPAGNE = this.campaignService.getAllCampaignsNoLimit();

  Observable.zip(
    ACTION_TYPES,
    LISTA_ACCUMULATORI,
    LISTA_CAMPAGNE
  ).subscribe(([
    res_act_type,
    res_acc,
    res_cl
  ]) => {
    // Action Types
    this.actionTypes = [];
    if (res_act_type && Array.isArray(res_act_type.data)) {
      for (const action of res_act_type.data) {
        this.actionTypes.push({
          label: action.description,
          value: action.id,
          code: action.code
        });
      }
    }

    // Lista accumulatori non bruciati
    this.acmNoBurned = res_acc;

    // Lista campagne
    if (res_cl && Array.isArray(res_cl) && res_cl.length > 0) {
      this.campaignList = res_cl;
    }
    this.showTable= true;

    console.log('Campagna *******************', this.campaign);
  });
}

  //Aprire le info delle azioni
  onOpenInfoAction(id: number | undefined) {

    if (id === undefined) {
      console.error("ID is undefined!");
      return;
    }
    if (!this.showPopupInfoInsideTable) {
      this.fetchSingleAction(id);
    }
  }

  fetchSingleAction(id: number) {

    this.testService.getSingleAction(id).subscribe(
      (res) => {
        console.log('SingleAction********', res);
        this.singleAction = res;
        console.log("apro la infotabella")
        this.showPopupInfoInsideTable = true;
      }
    )
  }

  onGetActionDescription(actionTypeId: number): string {
    let retValueObject = this.actionTypes.find(x => x.value == actionTypeId);
    let retVal;
    if (retValueObject == undefined) {
      retVal = 'ID not provided';
    } else {
      retVal = retValueObject.label;
    }
    return retVal;
  }

  onCreateNewAction() {
    this.router.navigate(["/campaign-3", this.campaign.id]);
  }
  //TODO
  onCreateNewMessage() {
    const campaignId = this.campaign.id;
    const newUrl = `/campaign-3/${campaignId}/MSG`;
    this.router.navigate([newUrl]);
  }

  onClosePopupInfo() {
    this.showPopupInfoInsideTable = false;
  }

  //per permettere controllo dei menù a tendina
  initMenuActivated() {
    for (let row of this.actionData.data) {
      row["menuActivated"] = false;
    }
  }

  toggleMenu(id: number, indexRow: number) {
    // Save the current state of the clicked menu
    let previousValue = this.actionData.data[indexRow].menuActivated;

    // Close all menus
    this.initMenuActivated();

    // Toggle the clicked menu based on its previous state
    this.actionData.data[indexRow].menuActivated = !previousValue;

    // Update the current opened row ID and the showMenu state
    this.currentOpenedRow = id;
    this.showMenu = this.actionData.data[indexRow].menuActivated;
  }

  toggleMenuCreation() {
    this.menuCreationActive = !this.menuCreationActive;
  }
  //per chiudere menù alla pressione fuori dalla ziona indicata
  @HostListener('document:click', ['$event'])
  onClick(event: any) {
    // Check if the click is outside the dropdown menu and the button
    if (!event.target.closest('.dropdown-menu') && !event.target.closest('.btn-details')) {
      // Close all menus
      this.initMenuActivated();

      // Update state
      this.showMenu = false;
      this.currentOpenedRow = null;
    }
  }

  editAction(row: any) {
    let actionId = row.id;
    let campaignId = row.campaign_id;
    this.showMenu = false;

    // Controlla se action_type è definito e non è null
    let actionType = row.action_type ? row.action_type.trim() : '';

    // Gestione degli errori nel caso in cui actionType sia vuoto
    if (!actionType) {
        console.error('action_type is undefined or empty.'); // Log dell'errore
        // Puoi anche mostrare un messaggio all'utente, ad esempio un toast
        alert('Errore: il tipo di azione è vuoto o non definito.'); // Puoi usare un sistema di notifica migliore
        return; // Esci dalla funzione se actionType non è valido
    }

    if (actionType === "Coupon") {
        this.router.navigate(["/campaign-3", campaignId, actionId]);
    } else if (actionType === "Messaggio") {
        this.router.navigate(["/campaign-3", campaignId, actionId, "MSG"]);
    } else {
        console.warn(`Azione non riconosciuta: ${actionType}`); // Log per un'azione non riconosciuta
        alert(`Azione non riconosciuta: ${actionType}`); // Messaggio all'utente
    }
}


  checkOnlyRead(row) {
    let retValue;
    if (this.language == "it") {
      retValue = "Guarda Azione";
    } else {
      retValue = "Open Action";
    }

    // let couponCheck = this.couponCheck(row);
    let dateCheck = this.dateCheck(row);
    /*  if (couponCheck && dateCheck) { */
    if (dateCheck) {
      if (this.language == "it") {
        retValue = "Modifica Azione";
      } else {
        retValue = "Edit Action";
      }
    }
    return retValue;
  }



  //controllo che sia un coupon
  couponCheck(row) {

    let retValue = false;
    let actionTypeCode = "CPN";
    let actionMessageTypeCode = "MSG";
    let selectedValue = this.actionTypes.find(a => a.code === actionTypeCode || a.code == actionMessageTypeCode );
    if (selectedValue && selectedValue.value == row.action_type_id) {
      retValue = true;
    }

    return retValue;

  }
  //controlllo che la campagnia non sia già terminata
  dateCheck(row) {

    let retValue = false;
    let campaign = this.campaignList.find(x => x.id == row.campaign_id);

    if (campaign) {
      let currentDate = new Date();
      let dateEndCampaign = new Date(campaign.end_date);
      if (currentDate < dateEndCampaign) {
        retValue = true;
      }
    }
    return retValue;
  }

  shouldDisable(row) {
    let retValue = false;
    let couponCheck = this.couponCheck(row);
    let dateCheck = this.dateCheck(row);
    if (couponCheck && dateCheck) {
      retValue = true;
    }
    return retValue;
  }



  showCoupons(id: number) {
    this.actionStateService.setCurrentCampaignId(this.campaign.id);
    this.router.navigate(['/coupon-list-3', id]);
  }


  onCheckEndCampaign() {
    let retValue = false;
  
    
    // Controlla se la data di fine è nel passato
    if (this.campaign.end_date && new Date(this.campaign.end_date) < new Date()) {
      retValue = true;
    }
    
    // Aggiungi la condizione per flg_state
    if (this.campaign.flg_state === "1") {
      retValue = true;
    }
    
    return retValue;
}

  //controlllo che la campagnia non sia già terminata
checkExpiredCampaign() {
    let campagna = this.campaign;
    let retValue = "";

    // Normalizzo le date per ignorare l'orario
    if (campagna.end_date) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const endDate = new Date(campagna.end_date);
        endDate.setHours(0, 0, 0, 0);

        if (endDate < today) {
            retValue = "disabled";
        }
    }

    // Controllo sul flg_state
    if (campagna.flg_state === "1") {
        retValue = "disabled";
    }

    return retValue;
}



  onRefreshTable() {
    this.refreshCampaignActions.emit();
  }
  onDeleteAction_OLD(row: any){
    let actionId = row.id;
    this.testService.deleteAction(actionId).subscribe(res => {
      console.log(res);
      this.refreshCampaignActions.emit();
    });
  }

  actionToDelete : any;
  displayDeleteDialog: boolean = false;
  onDeleteAction(row: any){

    console.log(row.status);
    this.displayDeleteDialog = true;
    this.actionToDelete=row;


   }

   closePopupDelete(){
    this.displayDeleteDialog = false;
   }


   onDefinitiveDelete(row: any) {
    let actionId = row.id;
    this.testService.deleteAction(actionId).subscribe(res => {
      console.log(res);
      this.displayDeleteDialog = false;
      this.refreshCampaignActions.emit();
    });


  }





  protected readonly JSON = JSON;
}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/action-table3/action-table3.component.ts